import PropTypes from 'prop-types';
import React, { Component } from 'react';

import {
  Bold,
  Container,
  Instructions,
  InstructionsContent,
} from './styles';

class URLQuestionType extends Component {
  componentDidMount() {
    this.answerQuestion();
  }

  answerQuestion = (touched = false) => {
    const { question, onQuestionAnswered } = this.props;
    const { id: questionId } = question;

    onQuestionAnswered({
      questionId,
      error: null,
      touched,
    });
  }

  onLinkClicked = () => (event) => {
    event.preventDefault();
  }

  render() {
    const {
      question: {
        labelPreview, label, questionType, imageUrl, videoUrl,
      },
    } = this.props;
    const isImageSelect = questionType === 'image_select';
    const isAudioVideo = questionType === 'audio_video';
    let url = labelPreview || label;
    let instructions = 'When the page has loaded, please click Next.';

    if (isImageSelect || isAudioVideo) {
      url = imageUrl || videoUrl;
      instructions = label;
    }

    return (
      <Container>
        <Bold>
          Please navigate to
          {' '}
          <a href={url} target="_blank" rel="noopener noreferrer">this website.</a>
        </Bold>
        <Instructions>
          <InstructionsContent>{instructions}</InstructionsContent>
        </Instructions>
      </Container>
    );
  }
}

URLQuestionType.propTypes = {
  question: PropTypes.object.isRequired,
  onQuestionAnswered: PropTypes.func.isRequired,
};

export default URLQuestionType;
